import { collectOrgIdsForAnyOrgPermission, requireAnySystemPermission, } from '@juvare/contact-management/backend/features/permissions/shared';
export function filterOrganizationIdsUserCanManageBadges(userState, organizationIds) {
    const orgIdsWhereCanManageMembers = collectOrgIdsForAnyOrgPermission(userState, 'manage-badges');
    const orgIds = organizationIds !== null && organizationIds !== void 0 ? organizationIds : [];
    return requireAnySystemPermission(userState, 'all-organizations-admin')
        ? orgIds
        : orgIds.filter((id) => orgIdsWhereCanManageMembers.includes(id));
}
